import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import axios, { all } from "axios";
import { Link, useOutletContext } from "react-router-dom";
import { useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import { decodeHtml } from "../../utils/decodeHtml";
function Role() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const [filterType, setFilterType] = useState("active");
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const navigate = useNavigate();
  const [options, setoptions] = useState([]);
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const [total_roles, settotal_roles] = useState(null);
  const [active_roles, setactive_roles] = useState(null);
  const [inactive_roles, setinactive_roles] = useState(null);
  const [closed_roles, setclosed_roles] = useState(null);

  const foptions = useRef();

  const columns = [
    {
      accessorKey: "role_name",
      header: "Role Name",
      size: 200,
      Cell: ({ row }) => (
        <Link
          to={`/role/view/${row.original.role_id}`}
          title={decodeHtml(row.original.role_name)}
          style={{
            display: "inline-block",
            maxWidth: "200px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {decodeHtml(row.original.role_name)}
        </Link>
      ),
    },
    {
      accessorKey: "company_name",
      header: "Clients",
      size: 150,
      Cell: ({ cell }) => (
        <span
          title={cell.getValue()}
          style={{
            display: "inline-block",
            maxWidth: "150px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {cell.getValue()}
        </span>
      ),
    },
    {
      accessorKey: "industrymaster",
      header: "Sector",
      size: 100,
      Cell: ({ cell }) => (
        <span
          title={cell.getValue()}
          style={{
            display: "inline-block",
            maxWidth: "100px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {cell.getValue()}
        </span>
      ),
    },
    {
      accessorKey: "industry",
      header: "Sub Sector",
      size: 100,
      Cell: ({ cell }) => (
        <span
          title={cell.getValue()}
          style={{
            display: "inline-block",
            maxWidth: "100px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {cell.getValue()}
        </span>
      ),
    },
    {
      accessorKey: "assignedTo",
      header: "Assigned To",
      size: 70,
    },
    {
      accessorKey: "role_manager",
      header: "Role Manager",
      size: 70,
    },
    {
      id: "allocations",
      header: "Allocation",
      accessorFn: (row) => row.allocations || [],
      filterFn: (row, id, filterValue) => {
        const allocations = row.original.allocations || [];

        return allocations.some((a) =>
          a.allocated
            .toLowerCase()
            .includes(filterValue.toLowerCase())
        );
      },
      Cell: ({ row }) => {
        const allocations = row.original.allocations || [];

        return (
          <div className="avatar-list-stacked avatar-group-sm">
            {allocations.map((allocation, index) => (
              <span
                key={index}
                className="avatar avatar-rounded ms-2"
                title={allocation.allocated}
              >
                <img
                  src={`${PINE_BASE_URL}/files/media/${allocation.userpic}`}
                  className="border border-white"
                  alt={allocation.allocated}
                />
              </span>
            ))}
          </div>
        );
      },
    },
    {
      accessorKey: "profile_added",
      header: "Profile Added",
      size: 70,
    },
    {
      accessorKey: "recommended",
      header: "Recommended",
      size: 70,
    },
    {
      accessorKey: "created_date",
      header: "Created Date",
      size: 70,
      Cell: ({ row }) => {
        const date = new Date(row.original.created_date);
        return <>{date.toLocaleDateString()}</>;
      },
    },
  ];
  const fetchOptions = async () => {
    setGlobalLoading(true); //  Show loader before API call
    try {
      const response = await axios.get(
        `${API_BASE_URL}/roles/get_roles_list/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setoptions(response.data.backup_items_list || []);
      setOptionsLoaded(true);
      settotal_roles(response.data.total_roles[0].total_roles);
      setactive_roles(response.data.active_roles[0].active_roles);
      setinactive_roles(response.data.inactive_roles[0].inactive_roles);
      setclosed_roles(response.data.closed_roles[0].closed_roles);
    } catch (error) {
      console.error("API Error:", error);
      setoptions([]); // Prevent errors from breaking UI
      setOptionsLoaded(true);
      setGlobalLoading(false);
    } finally {
      setOptionsLoaded(true);
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    if (foptions.current) return;
    foptions.current = true;
    fetchOptions();
  }, []);

  useEffect(() => {
    if (options.length > 0 || optionsLoaded) {
      setGlobalLoading(false);
      console.log(options);
    }
  }, [options]);

  useEffect(() => {
    $('[name="role_search"]').select2({
      multiple: false,
      closeOnSelect: true,
      ajax: {
        type: "POST",
        url: `${API_BASE_URL}/roles/roleLoad/`,
        dataType: "json",
        contentType: "application/json",
        delay: 250, // Delay for better UX
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        },
        data: function (params) {
          console.log(
            "Sending JSON:",
            JSON.stringify({ keywords: params.term }),
          ); // Debugging
          return JSON.stringify({ keywords: params.term }); // ✅ Send JSON payload
        },
        processResults: function (data) {
          console.log(data.options);
          if (!data.options || data.options.length === 0) {
            return {
              results: [],
            };
          }
          return {
            results: data.options.map((item, index) => ({
              id: item.value, // ✅ Add prefix to the ID
              value: item.value,
              text: item.label,
            })),
          };
        },
        cache: true,
      },
      placeholder: "Search Roles",
      allowClear: true,
      minimumInputLength: 1,
      tags: false,
      language: {
        noResults: function () {
          return "No Role found"; // Ensure "No results found" is displayed
        },
      },
      escapeMarkup: function (markup) {
        return markup;
      },
    });

    $("[name='role_search']").on("change", function () {
      const selectedValues = $(this).val() || [];
      navigate(`/role/view/${selectedValues}`);
    });

    return () => {
      $("[name='role_search']").off("change"); // Cleanup on unmount
    };
  }, [token, API_BASE_URL, setValue]);

  const get_filter_roles = async (type) => {
    try {
      setGlobalLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/roles/get_filter_roles_list/${type}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setoptions([]);
      console.log("Total roles", response.data.backup_items_list);

      setoptions(response.data.backup_items_list || []);
      setOptionsLoaded(true);
      setFilterType(type);
    } catch (error) {
      console.error("API Error:", error);
      setoptions([]); // Prevent errors from breaking UI
      setGlobalLoading(false);
      setOptionsLoaded(true);
    } finally {
      setOptionsLoaded(true);
      setGlobalLoading(false);
    }
  };

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Roles</h2>
          </div>
        </div>
        <div
          className="row justify-content-center"
          style={{ marginTop: "-20px" }}
        >
          <div
            style={{ cursor: "pointer" }}
            onClick={(e) => navigate("/role/add_new")}
            className="col-xl-4 col-md-6"
          >
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-people-arrows fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <a
                        href="javascript:void(0);"
                        className="text-secondary fw-semibold me-2 d-inline-block"
                        onClick={(e) =>
                          navigate("/role/add_new")
                        }
                      >
                        Create New Role
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/role/risk")}
            className="col-xl-4 col-md-6"
          >
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-fire fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link
                        to={"/role/risk"}
                        className="text-secondary fw-semibold me-2 d-inline-block"
                      >
                        Roles at Risk
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-4 col-md-6"
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate("/role/searchproposal")
            }
          >
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-magnifying-glass fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link
                        to={"/role/searchproposal"}
                        className="text-secondary fw-semibold me-2 d-inline-block"
                      >
                        Search Proposal
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 col-md-6 d-flex">
            <div
              className={`card flex-fill cursor-pointer ${filterType === "total" ? "border border-warning" : ""}`}
              onClick={() => get_filter_roles("total")}
            >
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-pink-transparent border border-pink d-flex align-items-center justify-content-center">
                        <i className="ti ti-users-group text-pink fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        Total Roles
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={total_roles ? total_roles : "0"}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 d-flex">
            <div
              className={`card flex-fill cursor-pointer ${filterType === "active" ? "border border-warning" : ""}`}
              onClick={() => get_filter_roles("active")}
            >
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-success-transparent border border-success d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-share fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        Active Roles
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={active_roles ? active_roles : "0"}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 d-flex">
            <div
              className={`card flex-fill cursor-pointer ${filterType === "inactive" ? "border border-warning" : ""}`}
              onClick={() => get_filter_roles("inactive")}
            >
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-danger-transparent border border-danger d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-pause fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        Inactive Roles
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={inactive_roles ? inactive_roles : "0"}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 d-flex">
            <div
              className={`card flex-fill cursor-pointer ${filterType === "closed" ? "border border-warning" : ""}`}
              onClick={() => get_filter_roles("closed")}
            >
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-info-transparent border border-info d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-plus fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        Closed Roles
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={closed_roles ? closed_roles : "0"}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header d-flex align-items-center row-gap-3">
            <h5>Quick Search:</h5>
            <div className="col-md-10 mx-sm-2">
              <div className="input-icon-end position-relative remove-icon">
                <select
                  style={{ width: "100%" }}
                  {...register("role_search", {
                    required: false,
                  })}
                  id="select-client"
                ></select>
              </div>
            </div>
            <div className="col-md-2">
              <button
                onClick={() =>
                  user.designation_id == 1 || user.admin == 1
                    ? navigate("/role/grid_view")
                    : navigate("/role/grid_view_user")
                }
                className="btn rounded-pill btn-outline-primary"
              >
                <i
                  className="fa-solid fa-arrow-up-right-from-square"
                  style={{ marginRight: "5px" }}
                ></i>
                Grid
              </button>
            </div>
          </div>
          <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <div className="row p-4 mt-3">
                {options.length > 0 && (
                  <MaterialReactTable
                    columns={columns}
                    data={options}
                    enableColumnFilters
                    enableGrouping
                    initialState={{
                      density: "compact",
                      // grouping: ["company_name"], // group by company_name
                      expanded: true, // expand groups by default
                      pagination: { pageSize: 100 },
                      columnOrder: [
                        "role_name",
                        "company_name",
                        "industrymaster",
                        "industry",
                        "assignedTo",
                        "role_manager",
                        "allocations",
                        "profile_added",
                        "recommended",
                        "created_date",
                      ],
                      columnPinning: {
                        left: [], // 👈 no pinned columns
                        right: [],
                      },
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Role;
